import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHHorarioIns = async (credentials, data) => {
  const body = {
    service: "RNHHorarioIns",
    params: {
      rnhHorarioCod: data?.cod || null,
      rnhHorarioNombre: data?.nombre || null,
      rnhHorarioTipo: data?.tipo || '',
      rnhHorarioFechaDesde: data?.desde || null,
      rnhHorarioFechaHasta: data?.hasta || null,
      rnhHorarioEsDefault: data?.default || null,
      rnhHorarioDescripcion: data?.descripcion || null,
    },
  };
  return respuestaDe(await axiosPost(body, credentials));
};